import { render } from "./collapse.vue?vue&type=template&id=f3fb246a&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=f3fb246a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f3fb246a"

export default script